import React from 'react'
import { useSnackbar } from 'notistack'
import {
  Box,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography
} from '@mui/material'
import { FormProvider, useForm } from 'react-hook-form'
import signUpService from '../../services/signUpService'
import { Link, useNavigate } from 'react-router-dom'
import SubmitButton from '../commonUIComponents/SubmitButton'

const SignUpPage = () => {
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const methods = useForm({ mode: 'onChange' })
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = methods
  const submitHandler = values => {
    return signUpService.signUp(values)
      .then(res => {
        enqueueSnackbar('Successfully Signed Up!', { variant: 'success' })
        navigate('/home')
      })
      .catch(err => enqueueSnackbar(err.response.data.message, { variant: 'error' }))
  }

  return (
    <Box>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submitHandler)}>
          <Grid container spacing={2}>
            <Grid item xs={4}/>
            <Grid item xs={4}>
              <Card variant="outlined">
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography variant="h5" component="div">
                        Sign Up
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Username"
                        {...register('username', { required: { value: true, message: 'Invalid Username' } })}
                        error={errors.username}
                        helperText={errors.username?.message}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Password"
                        type="password"
                        {...register('password', { required: { value: true, message: 'Invalid Password' } })}
                        error={errors.password}
                        helperText={errors.password?.message}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Nickname"
                        type="nickname"
                        {...register('nickname', { required: { value: true, message: 'Invalid Nickname' } })}
                        error={errors.nickname}
                        helperText={errors.nickname?.message}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="subtitle2" gutterBottom component="div">
                        Already a member? <Link to="/login" component={Link}>Log In</Link>
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <SubmitButton buttonLabel="Sign Up" loadingLabel="Sigining you up..." />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={4}/>
          </Grid>
        </form>
      </FormProvider>
    </Box>
  )
}

export default SignUpPage
